import { SubmissionParticipantForReception } from "@dune/types";
import { useMemo } from "react";
import { useGetConstructionSiteReceptionParticipants } from "../api/queries/constructionSiteSubmission.queries";

export const useReceptionParticipantsView = (
	constructionSiteId: number,
): {
	designers: SubmissionParticipantForReception[];
	builders: SubmissionParticipantForReception[];
	materials: SubmissionParticipantForReception[];
} => {
	const { data: receptionParticipants } =
		useGetConstructionSiteReceptionParticipants(constructionSiteId);

	return useMemo(() => {
		const result: {
			designers: SubmissionParticipantForReception[];
			builders: SubmissionParticipantForReception[];
			materials: SubmissionParticipantForReception[];
		} = { designers: [], builders: [], materials: [] };

		if (!receptionParticipants) return result;

		for (const {
			totalMissionsOrActivitiesOrMaterialTypes,
			participant,
			id,
			type,
			designerType,
			isFromSubmission,
			requiresLiftingReserves,
			totalFeesHT,
			totalFeesTTC,
		} of receptionParticipants) {
			const participantInsurer = participant.insurers.at(0)?.insurerSociety;

			const enriched: SubmissionParticipantForReception = {
				id,
				type,
				designerType,
				totalFeesHT,
				totalFeesTTC,
				totalMissionsOrActivitiesOrMaterialTypes:
					totalMissionsOrActivitiesOrMaterialTypes ?? [],
				participant: {
					...participant,
					isNewForReception: !isFromSubmission,
				},
				decennialCertificatesOfSubmissionOrValidFromOthers: null,
				requiresLiftingReserves,
				insurer: participantInsurer
					? {
							id: participantInsurer.id,
							denomination: participantInsurer.society.denomination,
						}
					: null,
			};

			if (type === "DESIGNER") result.designers.push(enriched);
			else if (type === "BUILDER") result.builders.push(enriched);
			else if (type === "MATERIAL") result.materials.push(enriched);
		}

		return result;
	}, [receptionParticipants]);
};
